import { Content, TableCell } from "pdfmake/interfaces";

export interface LineLegendRow {
  layerId: string;
  layerName: string;
  lineColor: string;
  iconSvg?: string;
}

const toLineCell = (color: string): TableCell => ({
  canvas: [
    {
      type: "line",
      x1: 0,
      y1: 6,
      x2: 40,
      y2: 6,
      lineWidth: 2,
      lineColor: color
    }
  ],
  margin: [0, 2, 0, 2]
});

const toIconCell = (iconSvg?: string): TableCell => {
  if (!iconSvg) {
    return {
      text: "-",
      alignment: "center",
      margin: [0, 0, 0, 0]
    };
  }

  return {
    svg: iconSvg,
    fit: [12, 12],
    margin: [0, 0, 0, 0]
  };
};

const getLegendTable = (rows: LineLegendRow[]): Content => {
  const tableWidths = [50, 20, 200];
  const tableTotalWidth = tableWidths.reduce((sum, width) => sum + width, 0);

  const body = rows.map((row) => [
    toLineCell(row.lineColor),
    toIconCell(row.iconSvg),
    {
      text: row.layerName,
      noWrap: true,
      margin: [0, 1, 0, 1]
    }
  ]);

  return {
    columns: [
      { width: "*", text: "" },
      {
        width: tableTotalWidth,
        table: {
          widths: tableWidths,
          body
        },
        layout: {
          hLineWidth: () => 0,
          vLineWidth: () => 0,
          paddingLeft: () => 0,
          paddingRight: () => 0,
          paddingTop: () => 2,
          paddingBottom: () => 2
        }
      },
      { width: "*", text: "" }
    ],
    columnGap: 0
  };
};

export default getLegendTable;
